// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__1Axfk","withMobileMargins":"DateRangeInput_withMobileMargins__3lvc1","arrowIcon":"DateRangeInput_arrowIcon__123UQ"};